import React, { FC } from 'react';
import styles from './Tabs.module.scss';
import cx from 'classnames';

interface TabsProps {
	onSelect: (tab: string) => void;
	activeTab: string;
}

const Tabs: FC<TabsProps> = ({ onSelect, activeTab }): JSX.Element => (
	<section className={`${styles.Tabs}`}>
		<div className={cx(styles.TabItem, { [styles.Active]: activeTab === 'info' })} onClick={() => onSelect('info')}>
			Player Info
		</div>
		<div className={cx(styles.TabItem, { [styles.Active]: activeTab === 'wallet' })} onClick={() => onSelect('wallet')}>
			Real Bonus Wallets
		</div>
	</section>
);

export { Tabs };
